import { Descriptions, Empty, Tag } from 'antd';

import {
  SOCIAL_EMPTY_TEXT,
  socialReasonsText,
  socialSlaTagColor,
  socialSourceEmptyKind,
  type SocialDataSource,
} from '@/lib/social';

/**
 * REDFOX 源级社交状态卡（§D5/§D7/§D8）。
 * 状态从 sla_verdict/sla_reasons/sla_color/config_status 渲染（不依赖 crawler 7-label 状态字段）；
 * 计数标「本次 run」（run-level 非累计）；缺 run / PAUSED / exempt → EmptyState（无假绿）。
 */
export default function SocialSourceCard({ source }: { source: SocialDataSource }) {
  const kind = socialSourceEmptyKind(source);
  const lr = source.latest_run;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-medium text-slate-900">{source.source_name}</span>
        <Tag>社交信号 · {source.source_type}</Tag>
        <Tag color={socialSlaTagColor(source.sla_color)}>SLA {source.sla_verdict}</Tag>
        <Tag>{source.config_status}</Tag>
      </div>
      <div className="text-[12px] text-slate-500">SLA 原因：{socialReasonsText(source.sla_reasons)}</div>

      {kind !== 'has_run' ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={SOCIAL_EMPTY_TEXT[kind]} />
      ) : (
        <Descriptions size="small" column={2} bordered>
          <Descriptions.Item label="最近采集 week">{lr?.week ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="采集时间">
            {lr?.crawl_time ? new Date(lr.crawl_time).toLocaleString('zh-CN') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="平台 / 关键词">
            {lr?.platform ?? '—'} / {lr?.query ?? '—'}
          </Descriptions.Item>
          <Descriptions.Item label="宿主">{source.host_role ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="API 调用（本次 run）">{lr?.api_call_count ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="取回 / 去重后（本次 run）">
            {lr?.items_returned ?? '—'} / {lr?.after_dedupe ?? '—'}
          </Descriptions.Item>
          <Descriptions.Item label="预算（calls / posts）">
            {source.budget_max_calls ?? '—'} / {source.budget_max_posts ?? '—'}
          </Descriptions.Item>
          <Descriptions.Item label="情绪">{source.sentiment_status}</Descriptions.Item>
        </Descriptions>
      )}
    </div>
  );
}
